import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["filterCollectionAutocomplete", "collectionAutocomplete"];

  declare filterCollectionAutocompleteTargets: HTMLInputElement[];
  declare filterCollectionAutocompleteTarget: HTMLInputElement;
  declare collectionAutocompleteTarget: HTMLInputElement;
  declare collectionAutocompleteTargets: HTMLInputElement[];
  declare hasFilterCollectionAutocompleteTarget: boolean;
  declare hasCollectionAutocompleteTarget: boolean;

  collectionAutocompleteTargetConnected(collectionAutocompleteTarget) {
    this.updateAutocompleteUrl(collectionAutocompleteTarget);
  }

  updateFilters() {
    this.collectionAutocompleteTargets.forEach((collectionAutocomplete) => {
      this.updateAutocompleteUrl(collectionAutocomplete);
    });
  }

  updateAutocompleteUrl(collectionAutocomplete) {
    if (this.hasFilterCollectionAutocompleteTarget) {
      const url = new URL(
        collectionAutocomplete.attributes[
          "data-inputs--autocomplete-url-value"
        ].value,
        `${document.location.protocol}/${document.location.host}`
      );
      this.filterCollectionAutocompleteTargets.forEach((filterElement) => {
        const filterValue = filterElement.value;
        const filterName = filterElement.dataset.filtername;
        if (filterValue) {
          url.searchParams.set(`${filterName}`, filterValue);
        } else {
          url.searchParams.delete(`${filterName}`);
        }
      });

      collectionAutocomplete.setAttribute(
        "data-inputs--autocomplete-url-value",
        url
      );
    }
  }
}
